import {useMutation, useSuspenseQuery} from '@tanstack/react-query';

import {clientRoutes} from "_api/client-routes";
import {deskToken, findDesk, findDeskByCount} from "_api/fetchers/Client/desks";
import {Court} from "_types/models/Court";
import {toastRequestError} from "_utils/axios";
import {Desk} from '_types/models/Desk';
import {RequestDeskToken} from "_types/requests/Client/desk";


export function useDesksByCourt(id: Court['id']) {
    const queryKey = [...clientRoutes.desks.listByCourt(id)] as const;

    const swr = useSuspenseQuery({
        queryKey,
        queryFn: findDeskByCount,
    });
    const desks = swr.data;

    return {...swr, desks} as const;
}

export function useDesk(id: string) {
    const queryKey = [...clientRoutes.desk(id).show] as const;

    const swr = useSuspenseQuery({
        queryKey,
        queryFn: findDesk,
    });
    const desk = swr.data;

    return {...swr, desk} as const;
}

export function useDeskToken(id: Desk['id']) {
    const mutationKey = [...clientRoutes.desk(id).token] as const;
    return useMutation({
        mutationKey,
        mutationFn: async (payload: RequestDeskToken) => {
            return deskToken(mutationKey, payload);
        },

        onMutate: async d => {

        },
        onSuccess: async d => {

        },
        onError: err => {
            toastRequestError(err);
        },
    });
}
